// eslint-disable-next-line
export default [
	{
		id: 1,
		isChecked: false,
		brand: "chivita",
		brandName: "Juice1 type",
	},
	{
		id: 2,
		isChecked: false,
		brand: "coca-cola",
		brandName: "Juice2 type",
	},
	{
		id: 3,
		isChecked: false,
		brand: "Amstel",
		brandName: "Juice3 type",
	},
	{
		id: 4,
		isChecked: false,
		brand: "Guiness",
		brand_alcohol: "trophy",
		brandName: "Juice4 type",
	},
	{
		id: 5,
		isChecked: false,
		brand: "Chivita",
		brand_alcohol: "stout",
		brandName: "Juice5 type",
	},
	{
		id: 6,
		isChecked: false,
		brand: "Jameson",
		brand_alcohol: "eagle",
		brandName: "Juice6 type",
	},
];
